import React, { Component } from 'react';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Step7 from './Step7';
import Step8 from './Step8';
import Step9 from './Step9';
import Step10 from './Step10';
import Step11 from './Step11';
import Step12 from './Step12';
import Step13 from './Step13';

class Form extends Component {
    render() {
        return (
            <div>
                <form method="post" action="/pdfnew">
                    <div>
                        <Step1 />
                        <Step2 />
                        <Step3 />
                        <Step4 />
                        <Step5 />
                        <Step6 />
                        <Step7 />
                        <Step8 />
                        <Step9 />
                        <Step10 />
                        <Step11 />
                        <Step12 />
                        <Step13 />

                    </div>
                    <div className="form-group">
                        <button name="submit" type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form.js